"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signupSuccess = exports.signupRequested = exports.signupError = exports.signup = exports.clearSignupError = exports.SIGNUP_SUCCESS = exports.SIGNUP_REQUESTED = exports.SIGNUP_ERROR = exports.CLEAR_SIGNUP_ERROR = void 0;
var _apex = require("../../apex");
var _queryParamsHelper = require("../../helpers/queryParamsHelper");
var _snackbarActions = require("./snackbarActions");
var _config = _interopRequireDefault(require("../../config"));
var _excluded = ["username", "email", "password", "matchingPassword"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var SIGNUP_SUCCESS = exports.SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
var SIGNUP_ERROR = exports.SIGNUP_ERROR = 'SIGNUP_ERROR';
var SIGNUP_REQUESTED = exports.SIGNUP_REQUESTED = 'SIGNUP_REQUESTED';
var CLEAR_SIGNUP_ERROR = exports.CLEAR_SIGNUP_ERROR = 'CLEAR_SIGNUP_ERROR';
var signup = exports.signup = function signup(payload) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var username, email, password, matchingPassword, additionalFields, AffiliateTag, userConfig, field, apex, response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            username = payload.username, email = payload.email, password = payload.password, matchingPassword = payload.matchingPassword, additionalFields = _objectWithoutProperties(payload, _excluded);
            AffiliateTag = payload.AffiliateTag;
            dispatch(signupRequested);
            if (window.location.search) {
              AffiliateTag = (0, _queryParamsHelper.getQueryParam)('aff');
            } else {
              AffiliateTag = window.localStorage.getItem('affiliateTag');
            }
            userConfig = _config["default"].BrokerSettings ? [{
              Name: 'Broker',
              Value: _config["default"].BrokerSettings.name
            }, {
              Name: 'Language',
              Value: _config["default"].BrokerSettings.language
            }] : [];
            for (field in additionalFields) {
              userConfig.push({
                Name: field,
                Value: additionalFields[field]
              });
            }
            _context.p = 1;
            apex = (0, _apex.getApex)();
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            return _context.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'signupError',
              text: _t.message,
              type: 'warning'
            })));
          case 3:
            _context.n = 4;
            return apex.connection.RegisterNewUser({
              UserInfo: {
                UserName: username || email,
                passwordHash: password,
                Email: email
              },
              UserConfig: userConfig,
              AffiliateTag: AffiliateTag,
              OperatorId: 1
            });
          case 4:
            response = _context.v;
            if (!response.UserId) {
              _context.n = 5;
              break;
            }
            dispatch(signupSuccess(response.UserId));
            _context.n = 6;
            break;
          case 5:
            return _context.a(2, response);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[1, 2]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var signupRequested = exports.signupRequested = {
  type: SIGNUP_REQUESTED,
  payload: {
    requesting: true
  }
};
var signupSuccess = exports.signupSuccess = function signupSuccess(userId) {
  return {
    type: SIGNUP_SUCCESS,
    payload: {
      userId: userId,
      requesting: false
    }
  };
};
var signupError = exports.signupError = function signupError(payload) {
  return {
    type: SIGNUP_ERROR,
    payload: {
      errorMsg: payload.errormsg,
      requesting: false
    }
  };
};
var clearSignupError = exports.clearSignupError = function clearSignupError() {
  return {
    type: CLEAR_SIGNUP_ERROR
  };
};